import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './DashboardIcons';
import { SectionCard, EmptyState } from './TodaySchedule';

const AlertRow = ({ item, severity }) => {
  const isExpired = severity === 'expired';
  const label = isExpired
    ? `منتهي منذ ${Math.abs(item.days_left)} يوم`
    : item.days_left === 0
      ? 'ينتهي اليوم'
      : `ينتهي بعد ${item.days_left} يوم`;
  return (
    <li
      className={`flex items-center gap-3 rounded-lg border px-3 py-2.5 ${isExpired ? 'border-red-200/70 bg-red-50/60' : 'border-amber-200/70 bg-amber-50/60'}`}
      data-testid={isExpired ? 'subscription-alert-expired-item' : 'subscription-alert-expiring-item'}
    >
      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${isExpired ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}>
        <Icon name="warning" className="w-4 h-4" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-semibold text-slate-800">{item.name}</div>
        <div className={`text-xs ${isExpired ? 'text-red-600' : 'text-amber-700'}`}>{label}</div>
      </div>
    </li>
  );
};

export const SubscriptionAlerts = ({ alerts }) => {
  const expired = alerts?.expired || [];
  const expiring = alerts?.expiring || [];
  const total = expired.length + expiring.length;

  return (
    <SectionCard
      title="تنبيهات الاشتراكات"
      icon="bell"
      testId="subscription-alerts"
      action={
        <Link to="/players" className="text-xs font-semibold text-teal-700 hover:text-teal-800" data-testid="subscription-alerts-view-all">
          إدارة الاشتراكات
        </Link>
      }
    >
      {total === 0 ? (
        <EmptyState icon="check" text="لا توجد اشتراكات منتهية أو قريبة الانتهاء حالياً" testId="subscription-alerts-empty" />
      ) : (
        <ul className="space-y-2.5" data-testid="subscription-alerts-list">
          {expired.slice(0, 5).map((item) => (
            <AlertRow key={`expired-${item.id}`} item={item} severity="expired" />
          ))}
          {expiring.slice(0, 5).map((item) => (
            <AlertRow key={`expiring-${item.id}`} item={item} severity="expiring" />
          ))}
        </ul>
      )}
    </SectionCard>
  );
};

export default SubscriptionAlerts;
